export default __webpack_public_path__ + "static/TeamViewer_Logo-ea38aba41e35281e29450c27ee0c8c33.png";